
export const sFechaPublicacion = '2025-12-29T16:55:19.7687007-06:00';
export const sVersion = 'vf1.1.512291655';
            